import { gql } from '@apollo/client';

export const QUERY_SORTING_CROSS_BORDER_ONLINE_24H_DETAIL_LIST = gql`
    query QuerySortingCrossBorderOnline24hDetailList(
        $input: SortingCrossBorderOnline24hDetailPageRequestInput!
    ) {
        querySortingCrossBorderOnline24hDetailList(input: $input) {
            content {
                hubId
                hubName
                customerName
                statDate
                bagNumber
                trackingNumber
                orderId
                handoverTime
                customsDeliveryTime
                bagArrivalTime
                smallParcelOnlineTime
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;
